import { render, staticRenderFns } from "./ProfileEditForm.vue?vue&type=template&id=cc8db9c0"
import script from "./ProfileEditForm.vue?vue&type=script&lang=js"
export * from "./ProfileEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports